import { render, staticRenderFns } from "./PanelInch85.vue?vue&type=template&id=2fdf8d0b&scoped=true&"
import script from "./PanelInch85.vue?vue&type=script&lang=js&"
export * from "./PanelInch85.vue?vue&type=script&lang=js&"
import style0 from "./PanelInch85.vue?vue&type=style&index=0&id=2fdf8d0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf8d0b",
  null
  
)

export default component.exports